import {Component, OnInit} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {Apollo} from "apollo-angular";
import {getAllServicesNavBar} from "../../../graphql/graphql.queris";

@Component({
  selector: 'app-services-list',
  standalone: true,
    imports: [
        NgForOf,
        NgIf
    ],
  templateUrl: './services-list.component.html',
  styleUrl: './services-list.component.css'
})
export class ServicesListComponent implements OnInit{
  servicios: any[] = [];
  serviciosVisibles: any[] = [];
  serviciosPorPagina = 6;
  paginaActual = 1;
  loading = true;
  error: any;

  constructor(
    private apollo: Apollo
  ) {
  }

  ngOnInit():void {
    this.apollo
      .watchQuery({
        query: getAllServicesNavBar
      })
      .valueChanges.subscribe((result: any) => {
      this.servicios = result?.data?.getAllServiciosProcedimientos;
      this.cargarMas();
      this.loading = result.loading;
      this.error = result.error;
    })
  }

  convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  cargarMas(): void {
    const inicio = (this.paginaActual - 1) * this.serviciosPorPagina;
    const fin = this.paginaActual * this.serviciosPorPagina;
    this.serviciosVisibles = this.serviciosVisibles.concat(this.servicios.slice(inicio, fin));
    this.paginaActual++;
  }





}
